import { render, staticRenderFns } from "./delivered-add-or-update.vue?vue&type=template&id=a0711664"
import script from "./delivered-add-or-update.vue?vue&type=script&lang=js"
export * from "./delivered-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./delivered-add-or-update.vue?vue&type=style&index=0&id=a0711664&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports